import state from './moduleReferManagementState.js'
import mutations from './moduleReferManagementMutations.js'
import actions from './moduleReferManagementActions.js'
import getters from './moduleReferManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

